import React from "react";
import { Box, Typography, TextField, Select, MenuItem, FormControl, InputAdornment } from "@mui/material";

interface MobileInputProps {
  field: string;
  formData: any;
  onChange: (field: string, value: string) => void;
  placeholder?: string;
  label?: string;
  required?: boolean;
  error?: string;
  readOnly?: boolean;
}

const MobileInput: React.FC<MobileInputProps> = ({
  field,
  formData,
  onChange,
  placeholder,
  label,
  required = false,
  error,
  readOnly = false,
}) => (
  <Box>
    <Typography variant="body2" className="form-label fw-medium">
      {label}
    </Typography>
    <Box
      sx={{
        display: "flex",
        border: error ? "1px solid #d32f2f" : "1px solid rgba(0, 0, 0, 0.23)",
        borderRadius: "4px",
        overflow: "hidden",
        "&:focus-within": {
          borderColor: error ? "#d32f2f" : "primary.main",
          borderWidth: "2px",
        },
      }}
    >
      <FormControl
        size="small"
        sx={{
          minWidth: "30%",
          flex: "0 0 30%",
          "& .MuiOutlinedInput-root": {
            backgroundColor: "#f5f5f5",
            border: "none",
            borderRadius: 0,
            "& fieldset": {
              border: "none",
            },
          },
          "& .MuiInputLabel-root": {
            display: "none",
          },
          "& .MuiSelect-select": {
            padding: "8px 12px",
            color: "#666",
            fontWeight: 500,
            cursor: readOnly ? "not-allowed" : "pointer",
          },
        }}
      >
        <Select
          value={formData[`${field}Code`] || "+91"}
          onChange={(e) => onChange(`${field}Code`, e.target.value)}
          displayEmpty
          readOnly={readOnly}
        >
          <MenuItem value="+91">+91</MenuItem>
          <MenuItem value="+1">+1</MenuItem>
          <MenuItem value="+44">+44</MenuItem>
        </Select>
      </FormControl>
      <TextField
        fullWidth
        size="small"
        type="tel"
        value={formData[field]}
        placeholder={placeholder}
        onChange={(e) => onChange(field, e.target.value)}
        error={!!error}
        InputProps={{
          readOnly: readOnly,
          endAdornment: required ? (
            <InputAdornment position="end">
              <span style={{ color: "red" }}>*</span>
            </InputAdornment>
          ) : undefined,
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            border: "none",
            borderRadius: 0,
            "& fieldset": {
              border: "none",
            },
            "&.Mui-error": {
              "& fieldset": {
                border: "none",
              },
            },
          },
          "& .MuiInputLabel-root": {
            display: "none",
          },
          "& .MuiInputBase-input": {
            padding: "8px 12px",
            cursor: readOnly ? "not-allowed" : "text",
            "&::placeholder": {
              color: error ? "#d32f2f" : "rgba(0, 0, 0, 0.6)",
              opacity: 1,
            },
          },
        }}
      />
    </Box>
    {error && (
      <Typography variant="caption" color="error" sx={{ mt: 0.5, display: "block" }}>
        {error}
      </Typography>
    )}
  </Box>
);

export default MobileInput;
